define('CustomerCategory.Categories', [
    'Categories',
    'Categories.Collection',
    'Categories.Utils',
    'CustomerCategory.Utils',
    'Profile.Model',
    'Configuration',
    'underscore'
], function CustomerCategoryCategories(
    Categories,
    CategoriesCollectionModule,
    CategoriesUtils,
    CustomerCategoryUtils,
    ProfileModelModule,
    ConfigurationModule,
    _
) {
    'use strict';

    var ProfileModel = ProfileModelModule.ProfileModel || ProfileModelModule;
    var Configuration = ConfigurationModule.Configuration || ConfigurationModule;

    _.extend(Categories, {
        removeUnseenCategories: function removeUnseenCategories(categories, customerCategory, categoriesGroup) {
            var self = this;
            var copyCategories = categories;

            _.each(copyCategories, function eachCategories(category) {
                var categoryGroup = categoriesGroup[category.internalid];

                if (CustomerCategoryUtils.isCategoryVisible(
                    categoryGroup,
                    customerCategory,
                    SC.ENVIRONMENT.currentHostString,
                    !!(categoriesGroup && categoriesGroup.length)
                )) {
                    category.categories = self.removeUnseenCategories(
                        category.categories || [],
                        customerCategory,
                        categoriesGroup
                    );
                } else {
                    copyCategories = _.without(copyCategories, category);
                }
            });
            return copyCategories;
        },

        mountToApp: function mountToApp(application) {
            var self = this;
            var CategoriesCollection = CategoriesCollectionModule.CategoriesCollection || CategoriesCollectionModule;
            var profile;
            var customerCategory;
            var categoriesGroup = SC.ENVIRONMENT.published.commerceCategoriesGroup || [];
            var webCategory;
            var profileCustomFields;
            var shouldRefreshCategories = false;

            function publishCategories(categories) {
                var sortedCategories = categories || [];

                if (CategoriesUtils.sortingBy && CategoriesUtils.getSortBy) {
                    sortedCategories = CategoriesUtils.sortingBy(
                        sortedCategories,
                        CategoriesUtils.getSortBy('menu')
                    );
                }

                SC.CATEGORIES = self.removeUnseenCategories(
                    sortedCategories,
                    customerCategory,
                    categoriesGroup
                );
                self.topLevelCategories = [];
                self.setTopLevelCategoriesUrlComponents(SC.CATEGORIES);
                self.addToNavigationTabs(SC.CATEGORIES);
            }

            function fetchCategories(blockStartup) {
                var categoriesFetch;

                try {
                    categoriesFetch = new CategoriesCollection({
                        level: Configuration.get('categories.menuLevel'),
                        preventDefault: true
                    }).fetch();
                } catch (error) {
                    console.log('Failed to start Dynamic Categories refresh');
                    if (blockStartup) {
                        self.categoriesPromise.resolve();
                    }
                    return null;
                }

                categoriesFetch
                    .then(function (model) {
                        publishCategories((model && model.data) || []);
                    })
                    .catch(function () {
                        console.log('Failed to get Dynamic Categories');
                    });

                if (blockStartup) {
                    categoriesFetch.always(function releaseCategoryStartupGate() {
                        self.categoriesPromise.resolve();
                    });
                }

                return categoriesFetch;
            }

            if (!Configuration.get('categories')) {
                this.categoriesPromise.resolve();
                return;
            }

            this.application = application;
            this.application.waitForPromise(this.categoriesPromise);

            // This module replaces the native Categories.mountToApp implementation,
            // so preserve its startup gate before building the filtered route table.
            // Otherwise a cold-cache direct category URL can start routing as a PDP.
            try {
                profile = ProfileModel.getInstance();
                profileCustomFields = profile && profile.get('customfields');
                webCategory = profileCustomFields && profileCustomFields.length && _.findWhere(profileCustomFields, { name: 'custentity6' });
                customerCategory = (webCategory && webCategory.value) || '1';
            } catch (profileError) {
                this.categoriesPromise.resolve();
                return;
            }

            // Match the native 2026.1 startup contract: a direct category URL
            // cannot render until categories exist. Short-cache data is absent in
            // local previews and may also be absent after a cache refresh.
            if (!SC.CATEGORIES || !SC.CATEGORIES.length) {
                fetchCategories(true);
                return;
            }

            try {
                publishCategories(SC.CATEGORIES);
            } finally {
                this.categoriesPromise.resolve();
            }

            shouldRefreshCategories = SC.ENVIRONMENT.siteSettings.isPersonalizedCatalogViewsEnabled && !profile.isAnnonymous();

            if (shouldRefreshCategories) {
                // Personalized refresh is optional and must never hold application
                // startup open. Apply it later when the collection request settles.
                fetchCategories(false);
            }
        }
    });
});
